'use client';

import React from 'react';
import NextBreadcrumb from '../Breadcrumbs/NextBreadcrumb';

type BreadcrumbItem = {
  slug: string;
  name: string;
}

type BreadcrumbList = BreadcrumbItem[];

interface HeaderProps {
  variant?: 'default' | 'dark' | 'light' | 'white';
  title?: string;
  description?: string;
  breadcrumbMap?: BreadcrumbList;
  hiddenPaths?: string[];
  isIndustryView?: boolean;
  isCustomPath?: boolean;
}

export default function Header({
  variant = 'default',
  title,
  description,
  breadcrumbMap,
  hiddenPaths,
  isIndustryView,
  isCustomPath = false
}: HeaderProps) {
  const breadcrumbVariant = variant === 'white' ? 'default' : variant;
  
  return (
    <header className={`w-full mt-16 lg:pt-10 ${variant === 'dark' ? 'bg-dark01' : variant === 'light' ? 'bg-light01' : variant === 'white' ? 'bg-white' : '' }`}>
      <div className="container lg:py-8">
        <NextBreadcrumb
          variant={breadcrumbVariant}
          titleCustom={title}
          descriptionCustom={description}
          breadcrumbMap={breadcrumbMap}
          hiddenPaths={hiddenPaths}
          isIndustryView={isIndustryView}
          isCustomPath={isCustomPath}
        />
      </div>
    </header>
  );
}